export const getProjectBackgroundImage = async () => {
  return {
    src: "https://images.wallpaperscraft.com/image/single/skyscraper_building_architecture_112550_3840x2160.jpg",
    title: "Our Projects",
    subTitle:
      "Innovative Solutions for a Better Tomorrow: Our Success Stories",
  };
};
